export default {"src":"/_next/static/image/public/assets/feature-images/en/style-various.8ba7c276f7aea9e39281ce0ef5e43041.svg","height":379,"width":510};